import { PlusIcon } from "../../assets/icons";
import CommonButton from "../../components/commonButton";
import { usePermission } from "../../hooks/usePermission";
import { TableSearch } from "../../components/form/Fields";

const MODULE = "map_jantri";

const NpaAddImpExprtBtn = ({
  searchQuery,
  setSearchQuery,
  onAddMapClick,
  onBulkAddClick,
  isFileLevel,
  showDeleted,
  onToggleDeleted,
  title
}) => {


  const { hasPermission } = usePermission();

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between flex-wrap gap-3">

        <TableSearch value={searchQuery} // Use the immediate typing state
          placeholder="Search"
          onChange={(e) => {
            // Update the searchQuery state with every keystroke.
            // The debounce useEffect will handle updating the filterValues.
            setSearchQuery(e.target.value);
          }} />

        {hasPermission(MODULE, "create") && (
          <div className="ms-auto d-flex align-items-center gap-3">
            {/* Deleted sheets are hidden by default; this is how an operator
                finds one to restore. File level only — locations are not
                soft-deletable. */}
            {isFileLevel && (
              <label className="tp-deleted-toggle mb-0">
                <input
                  type="checkbox"
                  checked={Boolean(showDeleted)}
                  onChange={(e) => onToggleDeleted?.(e.target.checked)}
                />
                <span>Show deleted</span>
              </label>
            )}

            {/* Only at file level: there is nothing to bulk upload into a
                location that still has sub-locations under it. */}
            {isFileLevel && (
              <CommonButton
                variant="primary"
                className="btn-primary-light"
                title="Bulk Upload"
                onClick={(e) => {
                  e.stopPropagation();
                  onBulkAddClick();
                }}
              />
            )}

            <CommonButton
              icon={<PlusIcon size={14} />}
              variant="primary"
              title={`Add ${title}`}
              onClick={(e) => {
                e.stopPropagation();
                onAddMapClick();
              }}
            />
          </div>
        )}
        {/* <CommonButton
            icon={<span><img src={ExportImportImg} alt="import" /></span>}
            className="btn-primary-light me-2"
            title="Export"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleExportNpaProperties();
            }}
          /> */}
        {/* <CommonButton
            icon={<span><img src={AddPropertyImg} alt="import" /></span>}
            className="btn-primary"
            title="Add Property"
            onClick={(e) => {
              e.stopPropagation();
              navigate(routes.addBrokerProperty);
            }}
          /> */}
      </div>

    </>
  );
};

export default NpaAddImpExprtBtn;
